export default __webpack_public_path__ + "static/media/product_7.93133456.png";